import { Fragment, useState } from 'react';
import Box from '@mui/material/Box';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { Button } from '@mui/material';
import { useTranslate } from 'react-admin';
import Typography from '@mui/material/Typography';
import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import ButtonsBlock from '@/components/common/buttons-block/buttons-block';

interface Props {
    imageDataBase64: string;
    name: string;
}

const ShowNoteSignItem = ({ imageDataBase64, name }: Props) => {
    const translate = useTranslate();
    const [showDialogState, setShowDialogState] = useState<boolean>(false);

    const handleShowDialogOpen = () => {
        setShowDialogState(true);
    };

    const handleShowDialogClose = () => {
        setShowDialogState(false);
    };

    return (
        <Fragment>
            <Box
                sx={{
                    display: 'grid',
                    alignContent: 'start',
                    gap: 1,
                }}
            >
                <Typography>{translate(`notes.signatures_labels.${name}`)}</Typography>

                <Box
                    onClick={handleShowDialogOpen}
                    component='img'
                    sx={{
                        // maxHeight: 150,
                        border: (theme) => `1px solid ${theme.palette.action.disabled}`,
                        borderRadius: 1,
                        maxWidth: '100%',
                        ':hover': {
                            cursor: 'pointer',
                        },
                    }}
                    src={imageDataBase64}
                />
            </Box>

            <DialogTemplate
                icon={<BorderColorIcon />}
                title={translate('app.signs')}
                open={showDialogState}
                onClose={handleShowDialogClose}
                maxWidth={'lg'}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gap: 2,
                    }}
                >
                    <Box
                        component='img'
                        sx={{
                            border: (theme) => `1px solid ${theme.palette.action.disabled}`,
                            borderRadius: 1,
                            maxWidth: '100%',
                        }}
                        src={imageDataBase64}
                    />

                    <ButtonsBlock>
                        <Button onClick={handleShowDialogClose} variant='contained'>
                            {translate('app.main_buttons.return')}
                        </Button>
                    </ButtonsBlock>
                </Box>
            </DialogTemplate>
        </Fragment>
    );
};

export default ShowNoteSignItem;
